export default __webpack_public_path__ + "static/media/fullscreenButton.01bb0a1b.svg";